import type { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { HeaderWrapper, LeftHeaderWrapper, SectionIconWrapper, SectionId, SectionTitle } from './SectionHeader.styles';

type TSectionHeaderProps = {
  sectionId?: string;
  sectionIcon: React.ElementType;
  sectionTitle: MasterTranslation;
  gutterBottom?: boolean;
};

const SectionHeader = ({ gutterBottom, sectionIcon: SectionIcon, sectionTitle, sectionId }: TSectionHeaderProps) => {
  const { t } = useGlobalState();

  return (
    <HeaderWrapper gutterBottom={gutterBottom}>
      <LeftHeaderWrapper>
        <SectionIconWrapper>
          <SectionIcon />
        </SectionIconWrapper>
        <SectionTitle>{t(sectionTitle)}</SectionTitle>
      </LeftHeaderWrapper>
      {sectionId && <SectionId>#{sectionId}</SectionId>}
    </HeaderWrapper>
  );
};

export { SectionHeader };
